var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLightning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0241 5.88086L4.77407 11.5059C4.71843 11.5652 4.645 11.6049 4.56484 11.6189C4.48468 11.6328 4.40215 11.6204 4.32971 11.5833C4.25726 11.5463 4.19883 11.4867 4.16323 11.4135C4.12763 11.3404 4.11679 11.2576 4.13235 11.1777L4.81954 7.74039L2.11813 6.72601C2.06011 6.70431 2.00838 6.66858 1.96754 6.622C1.92671 6.57542 1.89804 6.51946 1.88412 6.4591C1.87019 6.39875 1.87143 6.33588 1.88772 6.27612C1.90402 6.21636 1.93487 6.16157 1.97751 6.11664L7.22751 0.491637C7.28314 0.432263 7.35658 0.392596 7.43674 0.37862C7.51689 0.364645 7.59942 0.37712 7.67187 0.414163C7.74431 0.451206 7.80275 0.510807 7.83835 0.583972C7.87395 0.657138 7.88479 0.739897 7.86922 0.819762L7.18016 4.26086L9.88157 5.27382C9.93916 5.29567 9.99048 5.33137 10.031 5.37776C10.0715 5.42415 10.1 5.47981 10.1139 5.53981C10.1278 5.59982 10.1267 5.66232 10.1107 5.7218C10.0947 5.78128 10.0643 5.83591 10.0222 5.88086H10.0241Z",
    fill: "url(#paint0_linear_3172_3408)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3172_3408",
    x1: 1.87451,
    y1: 5.99875,
    x2: 10.1236,
    y2: 5.99875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C47A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC417"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightning);
export default __webpack_public_path__ + "static/media/Lightning.cbe1ec78979fd9a73d1f95e95a70ea45.svg";
export { ForwardRef as ReactComponent };